import styles from "./HeadingBlock.module.scss";

function HeadingBlock({ text }: { text: string }): React.JSX.Element {
  return <h2 className={styles.heading}>{text}</h2>;
}

export default HeadingBlock;
